import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CurrencyAdminItem from '../../../Domain/CurrencyAdminItem';
import CurrencyService from '../../../Services/CurrencyService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for currencies. Single page
// with <=6 fields renders as the compact centered DS modal.
export default class CurrencyWindowDescription {
  static titleForCreate = 'Create a new currency';
  static titleForEdit = 'Edit Currency';
  static entityName = 'Currency';
  static idField = 'CurrencyId';
  static nameField = 'Code';
  static itemType = CurrencyAdminItem;
  static serviceFunction = CurrencyService.UpsertCurrency;
  static messageOnSuccess = 'Currency has been saved.';
  static finishButtonLabel = 'Save';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Code',
          label: 'Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Symbol',
          label: 'Symbol',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-6',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
      ],
    },
  ];
}
